<template>
  <transition name="load-smooth" mode="out-in">
    <div v-if="carregando" key="antes">
      <h2 class="carregando">Carregando...</h2>
    </div>
    <div v-else key="depois">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'TableLoader',
  props: {
    carregando: {
      required: true,
      type: Boolean,
    }
  }
}
</script>

<style scoped>
.load-smooth-enter-active,
.load-smooth-leave-active {
  transition: opacity .3s;
}

.load-smooth-enter,
.load-smooth-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// index.vue?4bb4315a